// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import OperatingModeLookupPagingResultModel from '../../model/operating-mode-lookup-paging-result-model';
import OperatingModeLookupPagingResultDTO from '../dto/operating-mode-lookup-paging-result-dto';
import dtoSchema from '../schemas/operating-mode-lookup-paging-result-schema';
import OperatingModeLookupModel from '../../model/operating-mode-lookup-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class OperatingModeLookupPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<OperatingModeLookupPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => OperatingModeLookupModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: OperatingModeLookupModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<OperatingModeLookupPagingResultDTO>): OperatingModeLookupPagingResultModel;
  static toModel(dto: DeepPartial<OperatingModeLookupPagingResultDTO> | undefined | null): OperatingModeLookupPagingResultModel | undefined;
  static toModel(dto: DeepPartial<OperatingModeLookupPagingResultDTO> | undefined | null): OperatingModeLookupPagingResultModel | undefined {
    return dto ? new OperatingModeLookupPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<OperatingModeLookupPagingResultModel> | OperatingModeLookupPagingResultModel): OperatingModeLookupPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as OperatingModeLookupPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for OperatingModeLookupPagingResultModel, can not map to OperatingModeLookupPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
